<template>
  <div class="flex flex-col relative gap-y-4 p-5 pb-32">
    <div class="flex flex-col m-5 gap-y-8 container mx-auto">
      <BreadCrumbs :crumbs="crumbs" />

      <Title :title="'My Estimate'" />

      <div class="bg-white shadow-lg rounded-sm border border-slate-200 relative">
        <div class="p-5 text-sm bg-[#F8FAFC] font-medium border-b border-slate-200">
          Estimate totals
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-slate-200">
          <div class="p-6">
            <p class="text-sm text-slate-600 mb-1">Monthly cost</p>
            <p class="text-2xl font-bold text-slate-800">
              <span v-currency="totalMonthlyCost" :key="totalMonthlyCost">
                {{ totalMonthlyCost }}
              </span>
            </p>
          </div>

          <div class="p-6">
            <p class="text-sm text-slate-600 mb-1">Total 12 months</p>
            <p class="text-2xl font-bold text-slate-800">
              <span v-currency="totalCost" :key="totalCost">{{ totalCost }}</span>
            </p>
          </div>

          <div class="p-6">
            <p class="text-sm text-slate-600 mb-1">Services</p>
            <p class="text-2xl font-bold text-slate-800">{{ addedServices.length }}</p>
            <p v-if="onRequestCount" class="text-xs text-indigo-600 mt-1">
              {{ onRequestCount }} quoted individually
            </p>
          </div>
        </div>
      </div>
    </div>

    <CostBreakdown :services="addedServices" />

    <SummaryTable :addedServices="addedServices" />
    <Groups />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BreadCrumbs from "@/components/BreadCrumbs.vue";
import Title from "@/components/Title.vue";
import SummaryTable from "@/components/SummaryTable.vue";
import Groups from "@/components/Groups.vue";
import CostBreakdown from "@/components/CostBreakdown.vue";

export default {
  components: {
    BreadCrumbs,
    Title,
    SummaryTable,
    Groups,
    CostBreakdown,
  },
  data() {
    return {
      crumbs: [
        { text: "Home", to: "/" },
        { text: "WX-One Pricing Calculator", to: "/calculator" },
        { text: "My Estimate" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      addedServices: "services/addedServices",
      totalMonthlyCost: "services/totalMonthlyCost",
      totalCost: "services/totalYearlyCost",
    }),
    onRequestCount() {
      return this.addedServices.filter((service) => service.onRequest).length;
    },
  },
};
</script>

<style lang="postcss" scoped></style>
